import * as i18n from "../../i18n.ts";
import * as Html from "../../util/Html.ts";
import * as modal from "../../util/modal.ts";
import { markValidNative, markInvalidNative } from "../../util/forms.ts";
import * as amplify from "../../util/amplify.ts";
import * as CustomInput from "../../util/CustomInput.ts";

import ApiServer from "../../ApiServer.ts";


function initDom(trNode: HTMLElement){
  const amountInput = trNode.querySelector('input[name=amount]') as HTMLInputElement;
  const dateInput = trNode.querySelector('input[name=startDate]') as HTMLInputElement;
  const categorySelect = trNode.querySelector('select[name=budgetCategoryId]') as HTMLSelectElement;

  if(!amountInput) return;

  CustomInput.setAmountValue(amountInput, 0);

  const tds = trNode.querySelectorAll('td');
  tds.forEach(td => (td as HTMLElement).style.overflow = 'visible');

  const inputs = trNode.querySelectorAll<HTMLElement>('input, select');
  inputs.forEach(input => {
    input.addEventListener('keydown', (ev: KeyboardEvent) => {
      if(ev.keyCode===10 || ev.keyCode===13){
        trNode.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
      if(ev.keyCode===27){//escape
        trNode.remove()
      }
    });
  });

  amountInput.addEventListener('change', function(){
    const value = Math.abs(CustomInput.getAmountValue(amountInput));
    if(isNaN(value)||value===0){
      markInvalidNative(amountInput, i18n.get('budget.transactionerrors.amount'));
      amountInput.select();
    }else{
      CustomInput.setAmountValue(amountInput, value);
      markValidNative(amountInput);
    }
  });

  amountInput.addEventListener('focus', function(){
    this.select()
  });

  trNode.addEventListener('submitnode', function(event){
    const value = Math.abs(CustomInput.getAmountValue(amountInput));
    if(isNaN(value)||value===0){
      markInvalidNative(amountInput, i18n.get('budget.transactionerrors.amount'));
      amountInput.select();
      return;
    }
    //WARNING it is a TR not a form, TODO find a better way to do that
    ApiServer.budgettransactionput(trNode as HTMLFormElement, function(){
      amplify.publish("tableaddmode",true)
    },async function(err){
      if(err.code==='502' && err.message.indexOf('non-recurrent budget')>-1){
        await modal.alert({title:'communication.justonemorething',message:"fw2.apierrors.502transactionrecurrencyend"})
        const recurrencyEnd = document.querySelector<HTMLElement>('*[data-widget="widget/form/recurrencyend"]');
        if (recurrencyEnd) recurrencyEnd.click();
      }else{
        throw err;
      }
    })
  });

}

export {initDom}
Html.registerWidget('widget/form/budgetTransactionInlineForm',{initDom})
